module.exports = __webpack_public_path__ + "img/video-link-img.b9771648.png";